module.exports = __webpack_public_path__ + "img/073619.3cde77e9.png";